module.exports = __webpack_public_path__ + "assets/2050fcf1c817b942cc0900875297f693.png";